import _ from 'underscore';

import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';

import {
  fbActions2SmartActionButtons,
  appendActions2Components,
} from './action-button-mapping';
import { truncateString } from './common-util';
import { updateWebsiteSourceDataWithBasicData } from './website-source-data-util';

export const businessNameMaxLength = 25;

// TODO: confirm with Jie for callToActions and hours
const validAttrs = [
  'businessDescription',
  'businessCategories',
  'businessName',
  'callToActions',
  'emails',
  'locationInfo',
  'logoImageId',
  'phoneNumber',
  'businessHours',
];

const fbDataSourceFilter = (originDataSource) => {
  const dataSource = _.pick(originDataSource, ...validAttrs);
  dataSource.businessName = truncateString(dataSource.businessName, businessNameMaxLength);

  return dataSource;
};

export const importConfigFromFbDataSource = (siteConfig, fbDataSource) => {
  const pageIndex = 0;
  const filteredFbDataSource = fbDataSourceFilter(fbDataSource);

  _.each(validAttrs, attr =>
    updateWebsiteSourceDataWithBasicData(siteConfig, filteredFbDataSource, attr, true));

  const newSiteConfig = {
    // Make sure the later update below L44 for pages is not touching the orignial obj......
    // Which makes the siteConfigReducer compares the same value in some cases.
    ...cloneDeep(siteConfig),
    dataSource: filteredFbDataSource,
    siteContextInfo: {
      facebookPageName: filteredFbDataSource.businessName,
    },
  };

  // TODO(Nickyang): We don't support multiple CTA now and this part of logic should
  // be changed as replace rather than insert.
  // map fbDataSource.callToActions to SmartActionButton component config and insert in siteConfig
  const standaloneActionCmps = fbActions2SmartActionButtons(fbDataSource);
  appendActions2Components(newSiteConfig.pages[pageIndex].components, standaloneActionCmps);

  return newSiteConfig;
};
